
export default {
    name: 'ArrowIcon',
};
